import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  getPersonalInfoFailure,
  getPersonalInfoSuccess,
  getStepsFailure,
  getStepsSuccess,
  setPasswordFailure,
  setPasswordSuccess,
  setPersonalInfoFailure,
  setPersonalInfoSuccess,
  getPayrollInfoFailure,
  getPayrollInfoSuccess,
  setPayrollInfoFailure,
  setPayrollInfoSuccess,
  validateEmployeeFailure,
  validateEmployeeSuccess,
  getStepDataFailure,
  getStepDataSuccess,
  saveResponseFailure,
  saveResponseSuccess,
  deleteAnswerFailure,
  deleteAnswerSuccess,
  updateStatusFailure,
  updateStatusSuccess,
  getRequiredDocsFailure,
  getRequiredDocsSuccess,
} from "./actions";
import {
  GET_PERSONAL_INFO,
  GET_STEPS,
  SET_PASSWORD,
  SET_PERSONAL_INFO,
  GET_PAYROLL_INFO,
  SET_PAYROLL_INFO,
  VALIDATE_EMPLOYEE,
  GET_STEP_DATA,
  SAVE_RESPONSE,
  DELETE_ANSWER,
  UPDATE_STATUS,
  GET_REQUIRED_DOCS,
} from "./constants";

export function* getStepsSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;

  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/${payload.id}/onboarding/steps`,
    );
    const { static_steps, form_steps } = data;
    let steps = [static_steps[0]];
    // form_steps.map((ele) => {
    //   ele.sequence = steps.length + 1;
    //   steps.push(ele);
    // });

    yield put(getStepsSuccess(steps));
    typeof callback === "function" && callback();
  } catch (e) {
    yield put(getStepsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching steps!"));
  }
}

export function* setPasswordSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/${payload.id}/onboarding/set-password`,
      payload,
    );
    yield put(setPasswordSuccess());
    typeof callback === "function" && callback();
  } catch (e) {
    yield put(setPasswordFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while setting password!"));
  }
}

export function* getPersonalInfoSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/${payload.id}/onboarding/personal-details`,
    );
    yield put(getPersonalInfoSuccess(data));
    typeof callback === "function" && callback();
  } catch (e) {
    yield put(getPersonalInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching personal info!"));
  }
}

export function* setPersonalInfoSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/${payload.id}/onboarding/personal-details`,
      payload,
    );
    yield put(successAlert("Personal info updated successfully!"));
    yield put(setPersonalInfoSuccess());
    typeof callback === "function" && callback();
  } catch (e) {
    yield put(setPersonalInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while setting personal info!"));
  }
}

export function* getPayrollInfoSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/${payload.id}/onboarding/payroll-info`,
    );
    yield put(getPayrollInfoSuccess(data));
    typeof callback === "function" && callback();
  } catch (e) {
    yield put(getPayrollInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching payroll info!"));
  }
}

export function* setPayrollInfoSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/${payload.id}/onboarding/payroll-info`,
      payload,
    );
    yield put(successAlert("Payroll info updated successfully!"));
    yield put(setPayrollInfoSuccess());
    typeof callback === "function" && callback();
  } catch (e) {
    yield put(setPayrollInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while setting payroll info!"));
  }
}

export function* validateEmployeeSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/check-onboarding-employee/${payload}`,
      payload,
    );
    yield put(validateEmployeeSuccess());
    typeof callback === "function" && callback(data);
  } catch (e) {
    yield put(validateEmployeeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while validating employee!"));
  }
}

export function* getStepDataSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/${payload.id}/onboarding/step/${payload.stepId}`,
      payload,
    );
    yield put(getStepDataSuccess(data));
    typeof callback === "function" && callback(data);
  } catch (e) {
    yield put(getStepDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching step data!"));
  }
}

export function* saveResponseSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/${payload.employeeId}/onboarding/step/${payload.stepId}`,
      payload?.data,
    );
    yield put(saveResponseSuccess(data));
    typeof callback === "function" && callback(data);
    yield put(successAlert("Response saved successfully!"));
  } catch (e) {
    yield put(saveResponseFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while saving response!"));
  }
}

export function* deleteAnswerSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).delete,
      `/api/employee/${payload.employeeId}/step/${payload.stepId}/response/${payload.answerId}`,
    );
    yield put(deleteAnswerSuccess(data));
    typeof callback === "function" && callback(data);
    yield put(successAlert("Answer deleted successfully!"));
  } catch (e) {
    yield put(deleteAnswerFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while deleting answer!"));
  }
}

export function* updateStatusSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/${payload.employeeId}/onboarding/update-status`,
      payload?.data,
    );
    yield put(updateStatusSuccess(data));
    typeof callback === "function" && callback(data);
  } catch (e) {
    yield put(updateStatusFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating status!"));
  }
}

export function* getRequiredDocsSaga({ payload }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee-onboarding-docs/${payload}`,
      payload,
    );
    yield put(getRequiredDocsSuccess(data?.steps));
  } catch (e) {
    yield put(getRequiredDocsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching required docs!"));
  }
}

export function* getStepsFlow() {
  yield takeEvery(GET_STEPS, getStepsSaga);
}
export function* setPasswordFlow() {
  yield takeEvery(SET_PASSWORD, setPasswordSaga);
}
export function* getPersonalInfoFlow() {
  yield takeEvery(GET_PERSONAL_INFO, getPersonalInfoSaga);
}
export function* setPersonalInfoFlow() {
  yield takeEvery(SET_PERSONAL_INFO, setPersonalInfoSaga);
}
export function* getPayrollInfoFlow() {
  yield takeEvery(GET_PAYROLL_INFO, getPayrollInfoSaga);
}
export function* setPayrollInfoFlow() {
  yield takeEvery(SET_PAYROLL_INFO, setPayrollInfoSaga);
}
export function* validateEmployeeFlow() {
  yield takeEvery(VALIDATE_EMPLOYEE, validateEmployeeSaga);
}
export function* getStepDataFlow() {
  yield takeEvery(GET_STEP_DATA, getStepDataSaga);
}
export function* saveResponseFlow() {
  yield takeEvery(SAVE_RESPONSE, saveResponseSaga);
}
export function* deleteAnswerFlow() {
  yield takeEvery(DELETE_ANSWER, deleteAnswerSaga);
}
export function* updateStatusFlow() {
  yield takeEvery(UPDATE_STATUS, updateStatusSaga);
}
export function* getRequiredDocsFlow() {
  yield takeEvery(GET_REQUIRED_DOCS, getRequiredDocsSaga);
}
export default function* EmployeeOnboardSaga() {
  yield all([
    getStepsFlow(),
    setPasswordFlow(),
    getPersonalInfoFlow(),
    setPersonalInfoFlow(),
    getPayrollInfoFlow(),
    setPayrollInfoFlow(),
    validateEmployeeFlow(),
    getStepDataFlow(),
    saveResponseFlow(),
    deleteAnswerFlow(),
    updateStatusFlow(),
    getRequiredDocsFlow(),
  ]);
}
